(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cobb-accessory-showcase"] && !Shopify.designMode) return;
  try {
    
const initCobbAccessories = (section) => {
  if (!section || section.dataset.cobbAccessoriesReady) return;
  section.dataset.cobbAccessoriesReady = 'true';
  const tabs = Array.from(section.querySelectorAll('[data-cobb-accessory-tab]'));
  const panels = Array.from(section.querySelectorAll('[data-cobb-accessory-panel]'));
  const tablist = section.querySelector('.cobb-accessories__tabs');
  const previous = section.querySelector('[data-cobb-accessory-previous]');
  const nextButton = section.querySelector('[data-cobb-accessory-next]');
  let activeIndex = 0;
  const activate = (index) => {
    activeIndex = (index + panels.length) % panels.length;
    tabs.forEach((tab, i) => { const active = i === activeIndex; tab.classList.toggle('is-active', active); tab.setAttribute('aria-selected', String(active)); tab.tabIndex = active ? 0 : -1; });
    panels.forEach((panel, i) => { const active = i === activeIndex; panel.hidden = !active; panel.classList.toggle('is-active', active); });
    if (tablist) {
      const activeTab = tabs[activeIndex];
      const target = activeTab.offsetLeft - (tablist.clientWidth - activeTab.offsetWidth) / 2;
      tablist.scrollTo({ left: Math.max(0, target), behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
    }
  };
  tabs.forEach((tab, index) => {
    tab.addEventListener('click', () => activate(index));
    tab.addEventListener('keydown', (event) => {
      let target = null;
      if (event.key === 'ArrowRight' || event.key === 'ArrowDown') target = index + 1;
      if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') target = index - 1;
      if (event.key === 'Home') target = 0;
      if (event.key === 'End') target = tabs.length - 1;
      if (target === null) return;
      event.preventDefault(); activate(target); tabs[activeIndex].focus();
    });
  });
  previous?.addEventListener('click', () => activate(activeIndex - 1));
  nextButton?.addEventListener('click', () => activate(activeIndex + 1));
  panels.forEach((panel) => {
    const pictures = Array.from(panel.querySelectorAll('[data-cobb-accessory-picture]'));
    const thumbs = Array.from(panel.querySelectorAll('[data-cobb-accessory-thumb]'));
    thumbs.forEach((thumb) => thumb.addEventListener('click', () => { const index = Number(thumb.dataset.cobbAccessoryThumb); pictures.forEach((picture, i) => { picture.hidden = i !== index; picture.classList.toggle('is-active', i === index); }); thumbs.forEach((item, i) => { const active = i === index; item.classList.toggle('is-active', active); item.setAttribute('aria-pressed', String(active)); }); }));
  });
  let touchStart = 0;
  section.querySelector('.cobb-accessories__panels')?.addEventListener('touchstart', (event) => { touchStart = event.touches[0].clientX; }, { passive: true });
  section.querySelector('.cobb-accessories__panels')?.addEventListener('touchend', (event) => { const distance = event.changedTouches[0].clientX - touchStart; if (Math.abs(distance) > 55) activate(activeIndex + (distance < 0 ? 1 : -1)); }, { passive: true });
  if (tabs.length) activate(0);
};
document.querySelectorAll('[data-cobb-accessories]').forEach(initCobbAccessories);
document.addEventListener('shopify:section:load', (event) => initCobbAccessories(event.target.querySelector('[data-cobb-accessories]')));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cobb-compatibility"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-cobb-compat]').forEach((section) => {
  const models = Array.from(section.querySelectorAll('[data-cobb-compat-model]'));
  const items = Array.from(section.querySelectorAll('[data-cobb-compat-item]'));
  const rows = Array.from(section.querySelectorAll('[data-cobb-compat-row]'));
  const count = section.querySelector('[data-cobb-compat-count]');
  const fits = (el, family) => family === 'all' || el.dataset[family] === 'true';
  const select = (button) => {
    const family = button.dataset.family;
    section.dataset.family = family;
    models.forEach((m) => {
      const active = m === button;
      m.classList.toggle('is-active', active);
      m.setAttribute('aria-pressed', String(active));
    });
    let visible = 0;
    items.forEach((item) => {
      const show = fits(item, family);
      item.hidden = !show;
      if (show) visible += 1;
    });
    rows.forEach((row) => row.classList.toggle('is-muted', !fits(row, family)));
    if (count) count.textContent = visible;
  };
  models.forEach((button) => button.addEventListener('click', () => select(button)));
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cobb-cooking-modes"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-cobb-modes]').forEach((section) => {
  const panels = Array.from(section.querySelectorAll('[data-cobb-mode-panel]'));
  const tabs = Array.from(section.querySelectorAll('[data-cobb-mode-tab]'));
  const tablist = section.querySelector('.cobb-modes__nav');
  const previous = section.querySelector('[data-cobb-mode-previous]');
  const nextButton = section.querySelector('[data-cobb-mode-next]');
  if (!panels.length || !tabs.length) return;
  let activeIndex = 0;
  const activate = (index) => {
    activeIndex = (index + panels.length) % panels.length;
    panels.forEach((panel, i) => { const active = i === activeIndex; panel.hidden = !active; panel.classList.toggle('is-active', active); });
    tabs.forEach((tab, i) => { const active = i === activeIndex; tab.classList.toggle('is-active', active); tab.setAttribute('aria-selected', String(active)); tab.tabIndex = active ? 0 : -1; });
    if (tablist) {
      const activeTab = tabs[activeIndex];
      const target = activeTab.offsetLeft - (tablist.clientWidth - activeTab.offsetWidth) / 2;
      tablist.scrollTo({ left: Math.max(0, target), behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
    }
  };
  tabs.forEach((tab, index) => {
    tab.addEventListener('click', () => activate(index));
    tab.addEventListener('keydown', (event) => {
      if (!['ArrowRight', 'ArrowLeft', 'Home', 'End'].includes(event.key)) return;
      event.preventDefault();
      const target = event.key === 'Home' ? 0 : event.key === 'End' ? tabs.length - 1 : index + (event.key === 'ArrowRight' ? 1 : -1);
      activate(target); tabs[activeIndex].focus();
    });
  });
  previous?.addEventListener('click', () => activate(activeIndex - 1));
  nextButton?.addEventListener('click', () => activate(activeIndex + 1));
  let touchStart = 0;
  section.querySelector('.cobb-modes__panels')?.addEventListener('touchstart', (event) => { touchStart = event.touches[0].clientX; }, { passive: true });
  section.querySelector('.cobb-modes__panels')?.addEventListener('touchend', (event) => { const distance = event.changedTouches[0].clientX - touchStart; if (Math.abs(distance) > 55) activate(activeIndex + (distance < 0 ? 1 : -1)); }, { passive: true });
  activate(0);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cobb-fuel-guide"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-cobb-fuel-guide]').forEach((section) => {
  const chips = Array.from(section.querySelectorAll('[data-cobb-fuel-chip]'));
  const cards = Array.from(section.querySelectorAll('[data-cobb-fuel-card]'));
  const narrow = window.matchMedia('(max-width: 989px)');
  chips.forEach((chip) => {
    chip.addEventListener('click', () => {
      const selected = chip.getAttribute('aria-pressed') !== 'true';
      chips.forEach((c) => c.setAttribute('aria-pressed', String(c === chip && selected)));
      if (!selected) {
        section.removeAttribute('data-active');
        cards.forEach((card) => card.classList.remove('is-match'));
        return;
      }
      section.setAttribute('data-active', chip.dataset.cobbFuelChip);
      cards.forEach((card) => card.classList.toggle('is-match', card.dataset.cobbFuelCard === chip.dataset.cobbFuelChip));
      const match = cards.find((card) => card.dataset.cobbFuelCard === chip.dataset.cobbFuelChip);
      if (match && narrow.matches) match.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cobb-how-it-works"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-cobb-how]').forEach((section) => {
  const controls = Array.from(section.querySelectorAll('[data-cobb-how-part]'));
  const activate = (index) => {
    controls.forEach((control) => {
      const active = control.dataset.cobbHowPart === String(index);
      control.classList.toggle('is-active', active);
      control.setAttribute('aria-pressed', String(active));
    });
  };
  controls.forEach((control) => {
    control.addEventListener('click', () => activate(control.dataset.cobbHowPart));
    if (control.classList.contains('cobb-how__hotspot')) control.addEventListener('mouseenter', () => activate(control.dataset.cobbHowPart));
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cobb-life-navigator"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-cobb-life]').forEach((section) => {
  const rail = section.querySelector('[data-cobb-life-rail]'); const cards = Array.from(section.querySelectorAll('[data-cobb-life-card]')); const backgrounds = Array.from(section.querySelectorAll('.cobb-life__backdrop-image')); const previous = section.querySelector('[data-cobb-life-previous]'); const next = section.querySelector('[data-cobb-life-next]'); const pause = section.querySelector('[data-cobb-life-pause]'); const progress = section.querySelector('[data-cobb-life-progress]'); const status = section.querySelector('[data-cobb-life-status]'); const reduced = window.matchMedia('(prefers-reduced-motion: reduce)'); if (!rail || !cards.length) return;
  const ofLabel = section.dataset.ofLabel || ' / '; let active = Math.min(Number(section.dataset.startIndex) || 0, cards.length - 1); let paused = reduced.matches; let timer; const interval = Math.max(Number(section.dataset.autoplaySeconds) || 6, 4) * 1000;
  const setActive = (index, scroll = true) => { active = (index + cards.length) % cards.length; cards.forEach((card, i) => card.classList.toggle('is-active', i === active)); backgrounds.forEach((background, i) => background.classList.toggle('is-active', i === active)); if (progress) progress.style.width = `${((active + 1) / cards.length) * 100}%`; if (status) status.textContent = `${cards[active].querySelector('.cobb-life__label')?.textContent || ''}, ${active + 1}${ofLabel}${cards.length}`; if (scroll) { const card = cards[active]; rail.scrollTo({ left: card.offsetLeft - (rail.clientWidth - card.clientWidth) / 2, behavior: reduced.matches ? 'auto' : 'smooth' }); } };
  const stop = () => window.clearInterval(timer); const start = () => { stop(); if (!paused && !reduced.matches && cards.length > 1) timer = window.setInterval(() => setActive(active + 1), interval); }; const move = (direction) => { setActive(active + direction); start(); };
  previous?.addEventListener('click', () => move(-1)); next?.addEventListener('click', () => move(1)); pause?.addEventListener('click', () => { paused = !paused; pause.setAttribute('aria-pressed', String(paused)); pause.textContent = paused ? pause.dataset.resumeLabel : pause.dataset.pauseLabel; start(); }); rail.addEventListener('mouseenter', stop); rail.addEventListener('mouseleave', start); rail.addEventListener('focusin', stop); rail.addEventListener('focusout', start); reduced.addEventListener?.('change', () => { paused = reduced.matches; start(); }); setActive(active, active > 0); start();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cobb-model-filter"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.customElements.get('cobb-model-filter')) return;

  var FAMILIES = {
    'premier-family': ['premier', 'premier-plus', 'premier-air', 'premier-gas', 'pro'],
    'supreme': ['supreme']
  };
  var PARAM = 'cobb_model';
  var STORAGE_KEY = 'cobb_model';

  function norm(value) {
    var v = String(value || '');
    try { v = decodeURIComponent(v); } catch (e) {}
    return v.trim().toLowerCase();
  }
  function handleFromHref(href) {
    var m = /\/products\/([^\/?#]+)/.exec(href || '');
    return m ? norm(m[1]) : null;
  }
  function familyOf(sel) {
    if (!sel) return '';
    if (sel === 'supreme') return 'supreme';
    if (FAMILIES[sel]) return sel;
    return FAMILIES['premier-family'].indexOf(sel) > -1 ? 'premier-family' : '';
  }
  function isValid(sel) { return !!sel && !!familyOf(sel); }
  function pluralIndex(locale, n) {
    var mod10 = n % 10, mod100 = n % 100;
    switch (locale) {
      case 'lt':
        if (mod10 === 1 && (mod100 < 11 || mod100 > 19)) return 0;
        if (mod10 >= 2 && mod10 <= 9 && (mod100 < 11 || mod100 > 19)) return 1;
        return 2;
      case 'lv':
        if (n === 0) return 2;
        if (mod10 === 1 && mod100 !== 11) return 0;
        return 1;
      case 'pl':
        if (n === 1) return 0;
        if (mod10 >= 2 && mod10 <= 4 && (mod100 < 12 || mod100 > 14)) return 1;
        return 2;
      default:
        return n === 1 ? 0 : 1;
    }
  }
  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  class CobbModelFilter extends HTMLElement {
    connectedCallback() {
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => this.init(), { once: true });
      } else {
        this.init();
      }
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
    }

    init() {
      if (this.initialized) return;
      this.initialized = true;
      this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      try { this.i18n = JSON.parse(this.querySelector('[data-cobb-mf-i18n]').textContent); } catch (e) { this.i18n = { labels: {} }; }
      var rows = [];
      try { rows = JSON.parse(this.querySelector('[data-cobb-mf-map]').textContent); } catch (e) { rows = []; }

      this.map = new Map();
      var missing = [];
      rows.forEach((row) => {
        var models = Array.isArray(row[2]) && row[2].length ? row[2].map(norm).filter(Boolean) : null;
        if (models && !models.length) models = null;
        [row[0], row[1]].forEach((key) => { if (key) this.map.set(norm(key), models); });
        if (!models) missing.push(row[3] + ' (' + row[0] + ')');
      });
      if (this.dataset.designMode === 'true' && missing.length) {
        console.info('[COBB model filter] ' + missing.length + ' product(s) without cobb.compatible_models (treated as universal):', missing);
      }

      this.buttons = Array.from(this.querySelectorAll('[data-cobb-model]'));
      this.status = this.querySelector('[data-cobb-status]');
      this.live = this.querySelector('[data-cobb-live]');
      this.empty = this.querySelector('[data-cobb-empty]');
      this.models = this.querySelector('[data-cobb-models]');
      this.lastCount = null;

      this.buttons.forEach((button) => button.addEventListener('click', () => this.onSelect(button)));

      var fromUrl = new URLSearchParams(window.location.search).get(PARAM);
      var initial = isValid(fromUrl) ? fromUrl : null;
      if (!initial) {
        try { initial = sessionStorage.getItem(STORAGE_KEY); } catch (e) { initial = null; }
      }
      this.selection = isValid(initial) ? initial : '';

      this.renderControls();
      this.apply(false);
      this.persist();
      this.observeGrid();
    }

    onSelect(button) {
      var value = button.dataset.cobbModel || '';
      var next = value;
      if (button.hasAttribute('data-cobb-family-card')) {
        if (familyOf(this.selection) === value) next = '';
      } else if (value && value === this.selection && value !== 'premier-family') {
        next = familyOf(value);
      }
      this.selection = next;
      this.renderControls();
      this.apply(true);
      this.persist();
      if (!next && button.closest('[data-cobb-empty]')) {
        var reset = this.querySelector('.cobb-mf__reset');
        if (reset) reset.focus();
      }
    }

    renderControls() {
      var sel = this.selection;
      var fam = familyOf(sel);
      this.buttons.forEach((button) => {
        var value = button.dataset.cobbModel || '';
        var pressed;
        if (button.hasAttribute('data-cobb-family-card')) pressed = !!fam && fam === value;
        else if (button.closest('[data-cobb-empty]')) return;
        else pressed = value === sel;
        button.setAttribute('aria-pressed', String(pressed));
      });
      var open = fam === 'premier-family';
      this.classList.toggle('is-open', open);
      if (this.models) {
        if (open) { this.models.removeAttribute('inert'); this.models.removeAttribute('aria-hidden'); }
        else { this.models.setAttribute('inert', ''); this.models.setAttribute('aria-hidden', 'true'); }
      }
      var premierCard = this.querySelector('[data-cobb-family-card][data-cobb-model="premier-family"]');
      if (premierCard) premierCard.setAttribute('aria-expanded', String(open));
    }

    label(key) {
      return (this.i18n.labels && this.i18n.labels[key]) || key;
    }

    badgeText(models) {
      var sel = this.selection;
      var fits = this.i18n.fits || 'Fits:';
      var target = FAMILIES[sel] || [sel];
      if (!FAMILIES[sel] || target.length === 1) return fits + ' ' + this.label(target[0]);
      var universal = models.indexOf('universal') > -1;
      var matched = target.filter((m) => models.indexOf(m) > -1);
      if (universal || matched.length === target.length) return fits + ' ' + (this.i18n.fitsAllFamily || this.label(sel));
      var names = matched.map((m) => this.label(m));
      return fits + ' ' + names.slice(0, 2).join(', ') + (names.length > 2 ? ' +' + (names.length - 2) : '');
    }

    apply(animate) {
      var grid = document.getElementById('CollectionProductGrid');
      var items = grid ? Array.from(grid.querySelectorAll('.m-product-item')) : [];
      var sel = this.selection;
      var target = sel ? (FAMILIES[sel] || [sel]) : null;
      var visible = 0;

      items.forEach((item) => {
        var old = item.querySelector('.cobb-mf-badge');
        if (old) old.remove();
        var host = item.querySelector('.cobb-mf-has-badge');
        if (host) host.classList.remove('cobb-mf-has-badge');

        var wasHidden = item.classList.contains('cobb-mf-hidden');
        if (!sel) {
          item.classList.remove('cobb-mf-hidden', 'cobb-mf-in');
          visible++;
          return;
        }
        var link = item.querySelector('a[href*="/products/"]');
        var handle = link ? handleFromHref(link.getAttribute('href')) : null;
        var known = handle && this.map.has(handle);
        var models = known ? this.map.get(handle) : null;
        var show = true;
        if (models) {
          show = models.indexOf('universal') > -1 || target.some((m) => models.indexOf(m) > -1);
        }
        item.classList.toggle('cobb-mf-hidden', !show);
        if (!show) { item.classList.remove('cobb-mf-in'); return; }
        visible++;
        if (animate && wasHidden && !this.reduceMotion) {
          item.classList.remove('cobb-mf-in');
          void item.offsetWidth;
          item.classList.add('cobb-mf-in');
        }
        if (models) {
          var media = item.querySelector('.m-product-card__media') || item.firstElementChild || item;
          media.classList.add('cobb-mf-has-badge');
          var badge = document.createElement('span');
          badge.className = 'cobb-mf-badge';
          badge.textContent = this.badgeText(models);
          media.appendChild(badge);
        }
      });

      this.updateStatus(visible, items.length, animate);
      if (this.observer) this.observer.takeRecords();
    }

    countText(n) {
      var i = this.i18n;
      var idx = pluralIndex(i.locale, n);
      var noun = (i.noun && (i.noun[idx] || i.noun[i.noun.length - 1])) || 'products';
      var verb = (i.verb && (i.verb[idx] || i.verb[i.verb.length - 1])) || 'fit';
      var sel = this.selection;
      var target;
      if (sel === 'premier-family') target = (i.targetFamily || '{family}').replace('{family}', this.label(sel));
      else target = (i.targetModel || '{model}').replace('{model}', this.label(sel));
      return { noun: noun, verb: verb, target: target };
    }

    updateStatus(visible, total, animate) {
      if (!this.status) return;
      var sel = this.selection;
      if (this.empty) this.empty.hidden = !(sel && total > 0 && visible === 0);
      if (!sel) {
        this.status.textContent = this.i18n.hint || '';
        if (this.live && this.lastCount !== null) this.live.textContent = (this.i18n.all || '') + ': ' + visible;
        this.lastCount = null;
        return;
      }
      var parts = this.countText(visible);
      var from = this.lastCount === null ? visible : this.lastCount;
      this.status.innerHTML = '<strong class="cobb-mf__num" data-cobb-num>' + from + '</strong> ' +
        escapeHtml(parts.noun) + ' ' + escapeHtml(parts.verb) + ' <strong>' + escapeHtml(parts.target) + '</strong>';
      var num = this.status.querySelector('[data-cobb-num]');
      var plain = visible + ' ' + parts.noun + ' ' + parts.verb + ' ' + parts.target;
      if (this.live) this.live.textContent = plain;
      this.lastCount = visible;
      if (!animate || this.reduceMotion || from === visible) { num.textContent = visible; return; }
      var start = null;
      var duration = 420;
      var step = (ts) => {
        if (start === null) start = ts;
        var p = Math.min(1, (ts - start) / duration);
        var eased = 1 - Math.pow(1 - p, 3);
        num.textContent = Math.round(from + (visible - from) * eased);
        if (p < 1 && num.isConnected) requestAnimationFrame(step);
      };
      requestAnimationFrame(step);
    }

    persist() {
      var sel = this.selection;
      try {
        if (sel) sessionStorage.setItem(STORAGE_KEY, sel);
        else sessionStorage.removeItem(STORAGE_KEY);
      } catch (e) {}
      try {
        var url = new URL(window.location.href);
        if (sel) url.searchParams.set(PARAM, sel);
        else url.searchParams.delete(PARAM);
        if (url.href !== window.location.href) window.history.replaceState(window.history.state, '', url.href);
      } catch (e) {}
    }

    observeGrid() {
      if (!('MutationObserver' in window)) return;
      // Observe the whole body: the theme's facets/sorting code swaps entire sections, so a narrower root can go stale.
      var root = document.body;
      this.observer = new MutationObserver((mutations) => {
        var relevant = mutations.some((m) => Array.from(m.addedNodes).some((node) =>
          node.nodeType === 1 && !(node.classList && node.classList.contains('cobb-mf-badge')) &&
          (node.matches('.m-product-item, #CollectionProductGrid, [data-product-container]') || node.querySelector('.m-product-item'))
        ));
        if (!relevant) return;
        clearTimeout(this.reapplyTimer);
        this.reapplyTimer = setTimeout(() => {
          this.lastCount = this.selection ? this.lastCount : null;
          this.apply(false);
          this.persist();
        });
      });
      this.observer.observe(root, { childList: true, subtree: true });
    }
  }

  window.customElements.define('cobb-model-filter', CobbModelFilter);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cobb-model-guide"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-cobb-model-guide]').forEach((section) => {
  if (section.dataset.cmgReady) return;
  section.dataset.cmgReady = '1';
  const chips = Array.from(section.querySelectorAll('[data-cmg-chip]'));
  const cards = Array.from(section.querySelectorAll('[data-cmg-card]'));
  const scroller = section.querySelector('[data-cmg-scroller]');
  const narrow = window.matchMedia('(max-width: 1099px)');
  chips.forEach((chip) => {
    chip.addEventListener('click', () => {
      const selected = chip.getAttribute('aria-pressed') !== 'true';
      chips.forEach((c) => c.setAttribute('aria-pressed', String(c === chip && selected)));
      if (!selected) {
        section.removeAttribute('data-active');
        cards.forEach((card) => card.classList.remove('is-match'));
        return;
      }
      const key = chip.dataset.cmgChip;
      section.setAttribute('data-active', key);
      let first = null;
      cards.forEach((card) => {
        const match = (card.dataset.tags || '').split(' ').includes(key);
        card.classList.toggle('is-match', match);
        if (match && !first) first = card;
      });
      if (first && scroller && narrow.matches) {
        const pad = parseFloat(getComputedStyle(scroller).paddingLeft) || 0;
        scroller.scrollTo({ left: first.offsetLeft - scroller.offsetLeft - pad, behavior: 'smooth' });
      }
    });
  });
  const toggle = section.querySelector('[data-cmg-toggle]');
  if (toggle) {
    toggle.addEventListener('click', () => {
      const open = toggle.getAttribute('aria-expanded') !== 'true';
      toggle.setAttribute('aria-expanded', String(open));
      section.classList.toggle('is-expanded', open);
      const text = toggle.querySelector('[data-cmg-toggle-text]');
      if (text) text.textContent = open ? toggle.dataset.less : toggle.dataset.more;
      const icon = toggle.querySelector('.cobb-model-guide__toggle-icon');
      if (icon) icon.textContent = open ? '−' : '+';
    });
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cobb-product-stage"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-cobb-stage]').forEach((section) => {
  const tabs = Array.from(section.querySelectorAll('[data-cobb-stage-tab]'));
  const base = section.querySelector('.cobb-stage__image');
  const detailImages = Array.from(section.querySelectorAll('[data-cobb-stage-image]'));
  const previous = section.querySelector('[data-cobb-stage-previous]');
  const nextButton = section.querySelector('[data-cobb-stage-next]');
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  if (!tabs.length) return;
  let activeIndex = 0;
  const activate = (index, reveal = true) => {
    activeIndex = (index + tabs.length) % tabs.length;
    tabs.forEach((tab, i) => { const active = i === activeIndex; tab.classList.toggle('is-active', active); tab.setAttribute('aria-selected', String(active)); tab.tabIndex = active ? 0 : -1; });
    if (detailImages.length) { const target = detailImages.find((image) => Number(image.dataset.cobbStageImage) === activeIndex); if (base) base.classList.toggle('is-active', !target); detailImages.forEach((image) => image.classList.toggle('is-active', image === target)); }
    if (reveal) tabs[activeIndex].scrollIntoView({ behavior: reduced.matches ? 'auto' : 'smooth', block: 'nearest', inline: 'center' });
  };
  tabs.forEach((tab, index) => { tab.addEventListener('click', () => activate(index)); tab.addEventListener('keydown', (event) => { if (!['ArrowDown','ArrowRight','ArrowUp','ArrowLeft'].includes(event.key)) return; event.preventDefault(); activate(index + (event.key === 'ArrowDown' || event.key === 'ArrowRight' ? 1 : -1)); tabs[activeIndex].focus(); }); });
  previous?.addEventListener('click', () => activate(activeIndex - 1));
  nextButton?.addEventListener('click', () => activate(activeIndex + 1));
  activate(0, false);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cobb-system-grid"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-cobb-system]').forEach((section) => {
  const rail = section.querySelector('[data-cobb-system-rail]');
  const cards = Array.from(section.querySelectorAll('[data-cobb-system-card]'));
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  if (!rail || cards.length < 2) return;
  let active = 0;
  const move = (direction) => { active = (active + direction + cards.length) % cards.length; cards[active].scrollIntoView({ behavior: reduced.matches ? 'auto' : 'smooth', block: 'nearest', inline: 'center' }); };
  section.querySelector('[data-cobb-system-previous]')?.addEventListener('click', () => move(-1));
  section.querySelector('[data-cobb-system-next]')?.addEventListener('click', () => move(1));
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["quality-section"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-cobb-quality]').forEach((section) => {
  const modes = Array.from(section.querySelectorAll('[data-cobb-quality-mode]'));
  const desktop = window.matchMedia('(hover: hover) and (min-width: 1200px)');
  const activate = (mode) => {
    modes.forEach((item) => {
      const active = item === mode;
      item.classList.toggle('is-active', active);
      item.querySelector('.cobb-quality__trigger').setAttribute('aria-expanded', String(active));
    });
  };
  modes.forEach((mode) => {
    mode.querySelector('.cobb-quality__trigger').addEventListener('click', () => activate(mode));
    mode.addEventListener('mouseenter', () => { if (desktop.matches) activate(mode); });
    mode.addEventListener('focusin', () => activate(mode));
  });
});

  } catch(e) { console.error(e); }
})();
})();
